export default function initAndra() {
  var $secondA = $('.block-filter-holder .more');
  $secondA.on('click', function (e) {
    e.preventDefault();

    $(this).fadeOut('fast', function () {
      $(this).siblings(".filter-list").find("li:hidden").show();
    });
  });
  return false;
}